module.exports = __webpack_public_path__ + "img/faq.745e46a5.png";